import React, { useEffect, useState, useRef } from 'react';
import CloseBar from "../../../assets/images/ttd/close-sidebar.png"
import { useForm } from "react-hook-form";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

function NegativeRate({ negativeRate, setNegativeRate, handleNegRating }) {
    const [showinput, setShowInput] = useState(false)
    const { register, formState: { errors }, handleSubmit, setValue, clearErrors,reset } = useForm();
    const reasonList = ["Harmful or Offensive","Not Relevant", "Too Repetitive", "Not Accurate", "Other"]
    const inputRef = useRef(null)
    const handleRadioChange = (data) => {
        console.log(data, "data 11")
        clearErrors("reason")
        if (data === "Other") {
            setValue("reason", "")
            setShowInput(true)
        } else {
            setShowInput(false)
            setValue("reason", data)
        }
    }
    const formSubmit = (data) => {
        handleNegRating(data?.reason)
        setNegativeRate(false)
    }

    useEffect(()=>{
        reset()
    },[negativeRate])

    function scrollToTarget() {
        const target = document.getElementById('targetBtn');
        setTimeout(() => {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }, 500);
    }

    return (
        <>
            {
                negativeRate ?
                    <div className="drawer-overlay" onClick={() => setNegativeRate(false)}></div>
                    : null
            }
            <div className={`leave-message-wrapper negative-rate-wrapper ${negativeRate ? "show-leave-form" : ""}`}>
                <div className="green-mark"></div>
                <HighlightOffIcon className="closebar-toggler" onClick={() => setNegativeRate(false)} />
                <div className="drawer-header">
                    Add a reason
                </div>
                <form onSubmit={handleSubmit(formSubmit)}>
                    <div className="drawer-body">
                        {reasonList.map((data, j) => (
                            <div className="radio-list-wrap" >
                                <input type="text" className='input-hidden' {...register("reason", { required: { value: "true", message: "Please select atleast one reason." } })} />
                                <label className="item-radio radio-block">
                                    <input className="form-check-input" type="radio" name="reasonVal" value={data} onChange={() => handleRadioChange(data)} />
                                    <div className="radio-content"></div>
                                    <div className='text'>{data}</div>
                                </label>
                            </div>
                        ))}

                        {
                            showinput && <textarea placeholder='Enter reason...' className='form-control' {...register("reason", { required: { value: "true", message: "Please enter reason." } })} id="targetBtn" onClick={()=> scrollToTarget()} ></textarea>
                        }
                        {errors?.reason && <div className='error'>{errors?.reason?.message}</div>}
                        <div className="form-action-group">
                            <button className="btn btn-default btn-rounded-full">Submit</button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}
export default NegativeRate;
